import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { getLangCountryPrefix } from '../../../../helpers/utils';
import promoMedia from '../../../../theme/promoMedia';
import { Tile } from '../Tile/Tile';

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 32px;

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        margin: 0 -20px 64px;
    }
`;

const TileContainer = styled.div`
    padding: 0 0 24px 0;
    width: 100%;

    &:last-child {
        padding-bottom: 0;
    }

    ${promoMedia.tablet744} {
        padding: 0 0 32px 0;
    }

    ${promoMedia.desktop1440} {
        padding: 0 20px 40px 20px;
        width: ${(props) => (props.fullwidth ? '100%' : '50%')};
        box-sizing: border-box;

        &:nth-last-child(2) {
            padding-bottom: ${(props) => (props.fullwidth ? null : '0')};
        }
    }
`;

export const TilesSection = (props) => {
    return (
        <Container>
            {Array.isArray(props.data) &&
                props.data
                    .filter((item) => item !== null)
                    .map((item) => {
                        return (
                            <TileContainer key={item.id} fullwidth={item.fullwidth || item.variant === 'withoutBorder'}>
                                <Tile
                                    variant={item.variant}
                                    title={item.title}
                                    subtitle={item.subtitle}
                                    titleColor={item.color?.titleColor}
                                    titleGradient={item.color?.titleGradient}
                                    bgColor={item.color?.bgColor ? item.color?.bgColor : 'aubergine01'}
                                    img={item.img}
                                    imgTop={item.imgTop}
                                    fullwidth={item.fullwidth}
                                    btn_title={item.btn_title}
                                    url={item?.add_country_lang_inside_link ? `${getLangCountryPrefix(props.lang, props.country)}${item.url}` : item.url}
                                    grayText={props.grayText}
                                    responsive={props.responsive}
                                    loadingLazy={props.loadingLazy}
                                />
                            </TileContainer>
                        );
                    })}
        </Container>
    );
};
TilesSection.propTypes = {
    data: PropTypes.array,
    loadingLazy: PropTypes.bool,
};
